import { memo } from 'react'

import s from './Subscription.module.scss'

import { DiscordIcon } from 'assets/icons/socials/DiscordIcon'
import { LinkedInIcon } from 'assets/icons/socials/LinkedInIcon'
import { TelegramIcon } from 'assets/icons/socials/TelegramIcon'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { ModalFullScreen } from 'components/UI/ModalFullScreen/ModalFullScreen'

interface Props {
  onHide: () => void
  show: boolean
}

export const Subscription = memo(({ onHide, show }: Props) => {
  return  (
    <ModalFullScreen onHide={onHide} show={show} className={s.wrapper}>
      <ModalFullScreen.Title>Subscribe to Enterprise</ModalFullScreen.Title>
      <p className={s.subtitle}>Please, contact our specialist to discuss all the details.</p>
      <div className={s.socials}>
        <a href="https://t.me/+rPEWHyKEYVZjMTI6" target="_blank" rel="noreferrer">
          <TelegramIcon className={s.tgIcon} />
        </a>
        <a href="https://www.linkedin.com/in/yaroslavvolovoj/" target="_blank" rel="noreferrer">
          <LinkedInIcon className={s.tgIcon} />
        </a>
        <a href="https://discord.gg/hSewn9yP" target="_blank" rel="noreferrer">
          <DiscordIcon className={s.tgIcon} />
        </a>
      </div>
      <CustomButton variant="outlined" onClick={onHide} size="152" className={s.closeButton}>
        Close
      </CustomButton>
    </ModalFullScreen>
  )
})
